import api from "../api";
import * as Helpers from "@/helpers";
import store from "./../../store";
import {iniciarRequisicao, logout} from "../../helpers";
import {STATUS_HTTP} from "../statusHTTP";

export const buscarResultadoExportcaoProtheus = async (id_pedido) => {
  const config = {
    params: { id_pedido },
    headers: iniciarRequisicao()
  };

  const {data, status} = await api.get('/drp/exportacao-protheus/resultado', config).catch(logout);

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.exportacao;
  }

  logout();
}

export default {
  async Itens(params) {
    store.dispatch("loadingAux/habilitarLoading", true);
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("drp/pedido", { headers, params })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        store.dispatch("loadingAux/habilitarLoading", false);
        return resp.data;
      })
      .catch(() => {
        store.dispatch("loadingAux/habilitarLoading", false);
        Helpers.logout();
      });
  },
  async Salvar(params) {
    store.dispatch("loadingAux/habilitarLoading", true);
    const headers = Helpers.iniciarRequisicao();
    return await api
      .post("drp/pedido", params, {
        headers: headers
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        store.dispatch("loadingAux/habilitarLoading", false);
        return resp.data.itens;
      })
      .catch(() => {
        store.dispatch("loadingAux/habilitarLoading", false);
        Helpers.logout();
      });
  },
  async Excluir(data) {
    store.dispatch("loadingAux/habilitarLoading", true);
    const headers = Helpers.iniciarRequisicao();
    return await api
      .delete("drp/pedidos", {
        headers,
        data: data
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        store.dispatch("loadingAux/habilitarLoading", false);
        return resp.data;
      })
      .catch(() => {
        store.dispatch("loadingAux/habilitarLoading", false);
        Helpers.logout();
      });
  },
  async Finalizar(params) {
    store.dispatch("loadingAux/habilitarLoading", true);
    const headers = Helpers.iniciarRequisicao();
    return await api
      .post("/finalizar_", params, {
        headers: headers
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        store.dispatch("loadingAux/habilitarLoading", false);
        return "";
      })
      .catch(() => {
        store.dispatch("loadingAux/habilitarLoading", false);
        Helpers.logout();
      });
  },

  async getPedidosSeparacaoRobo(params) {
    const headers = iniciarRequisicao();
    return api.get("drp/automatico/lista-de-pedidos", {headers, params})
  },

  async getProdutosDoPedidoSeparacao(params) {
    const headers = iniciarRequisicao();
    return api.get("drp/automatico/lista-de-produtos-do-pedidos", {headers, params})
  },

  async deleteProdutosDoPedidoSeparacao(params) {
    const headers = iniciarRequisicao();
    return api.delete("drp/automatico/produto", {headers, params})
  }
};
